<template>
    <div :class="activeClass">
        <div class="dropdown" :class="selectedClass">
            <button class="btn form-control dropdown-toggle" type="button" id="search-model" data-bs-toggle="dropdown" aria-expanded="false">
                {{ displayText ?? label }}
            </button>
            <span v-if="selected?.length" class="vehica-form-button__clear vehica-form-button__clear--list" @click="clear"><i class="fas fa-times"></i></span>
            <ul class="dropdown-menu" aria-labelledby="search-model">
                <li v-if="noneSelected"><a class="dropdown-item disabled">Select Make</a></li>
                <template v-for="make in makes" :key="make.id">
                    <li>
                        <span class="dropdown-header" @click.stop="void(0)">
                            {{make.id}}
                        </span>
                    </li>
                    <li v-for="option in visibleModels(make.models, inStock)" :key="option.id">
                        <a :class="'dropdown-item' + isActive(option)" href="" @click.prevent="toggleModel(option, $event)">
                            <i :class="'fa fa-check me-2' + isVisible(option)"></i>
                            {{ option.id }}
                        </a>
                    </li>
                </template>
                <template v-if="!multiselect">
                    <li v-for="option in list" :key="option.id">
                        <a :class="'dropdown-item' + isActive(option)" href="" @click.prevent="toggleModel(option)">{{ option.id }}</a>
                    </li>
                </template>
            </ul>
        </div>
        <label class="vehica-results__field__label">
            {{ label }}
        </label>
    </div>
</template>
<script>
    export default {
        props: ['inStock', 'list', 'makes', 'multiselect', 'required', 'value'],
        emits: ['input'],
        data: function () {
            return {
                selected: [],
            }
        },
        computed: {
            activeClass() {
                return this.selected.length ? 'vehica-active' : '';
            },
            displayText() {
                var len = this.selected.length;
                if (len) {
                    let plus = len > 2 ? ' +' + (len - 2) : '';
                    return this.selected.slice(0, 2).map(s => s.id).join(', ') + plus;
                }
                return null;
            },
            label() {
                return 'Model' + (this.required ? ' *' : '')
            },
            noneSelected() {
                return !this.makes?.length && !this.list?.length;
            },
            selectedClass() {
                return this.selected.length ? 'selected' : '';
            }
        },
        methods: {
            clear() {
                this.selected = [];
                this.updated();
            },
            isActive(option, value) {
                return this.selected.includes(option) ? ' active' : '';
            },
            isVisible(option) {
                return this.selected.includes(option) ? '' : ' invisible';
            },
            refresh() {
                if (this.multiselect) {
                    if (this.value && this.makes?.length) {
                        const values = this.value.split(',').map(s => s.trim());
                        this.selected = this.makes.flatMap(m => m.models).filter(e => values.includes(e.id));
                    } else {
                        this.selected = [];
                    }
                } else {
                    if (this.value && this.list?.length) {
                        const value = this.value;
                        this.selected = [this.list.find(e => value === e.id)];
                    } else if (!this.value) {
                        this.selected = [];
                    }
                }
                this.updated();
            },
            toggleModel(option, event) {
                if (option) {
                    if (!this.multiselect) this.selected = [];
                    let index = this.selected.indexOf(option);
                    if (index >= 0) {
                        this.selected.splice(index, 1);
                    } else {
                        this.selected.push(option);
                    }
                }
                if (this.multiselect && event) {
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                }
                this.updated();
            },
            updated() {
                this.$emit('input', this.selected);
            },
            visibleModels(models, inStock) {
                return inStock ? models?.filter(m => !inStock || m.count) : models;
            },
        },
        watch: {
            list() {
                this.refresh();
            },
            makes() {
                this.refresh();
            },
            value() {
                this.refresh();
            },
        },
    }
</script>